"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var ConfigProvider_1 = require("../../ConfigProvider");
var Empty_1 = require("../../Empty");
function Placeholder(_a) {
    var colSpan = _a.colSpan, empty = _a.empty;
    var prefix = ConfigProvider_1.usePrefix('table-placeholder');
    var tabeLangData = ConfigProvider_1.useLangData('table');
    return (react_1.default.createElement("tr", { className: prefix },
        react_1.default.createElement("td", { colSpan: colSpan }, empty !== null && empty !== void 0 ? empty : react_1.default.createElement(Empty_1.Empty, { title: tabeLangData.emptyText }))));
}
exports.default = Placeholder;
//# sourceMappingURL=index.js.map